export default __webpack_public_path__ + "182232e23db0cd4751c7ed26669f6e38.svg";